import { getTenant } from '../../../theme/tokens'
export const MALAYSIAN_STATES = [
  'Malé',
  'Hulhumalé',
  'Addu City',
  'Fuvahmulah',
  'Kulhudhuffushi',
  'Thinadhoo',
  'Naifaru',
  'Mahibadhoo',
  'Eydhafushi',
  'Manadhoo',
  'Ungoofaaru',
  'Funadhoo',
  'Dhidhdhoo',
  'Veymandoo',
  'Felidhoo',
  'Viligili',
]
export const MALAYSIAN_BANKS = [
  'Bank of Maldives',
  'Maldives Islamic Bank',
  'State Bank of India (Malé)',
  'HSBC Maldives',
  'Mauritius Commercial Bank Maldives',
  'Habib Bank Maldives',
  'Commercial Bank of Maldives',
  'HDFC Bank (Maldives)',
  'Bank of Ceylon Maldives',
  'ICICI Bank (Maldives)',
]
// Backwards-compatible aliases
export const THAI_PROVINCES = MALAYSIAN_STATES
export const THAI_BANKS = MALAYSIAN_BANKS
export interface Supplier {
  id: string
  supplierType: 'company' | 'individual'
  name: string
  email: string
  phone: string
  useAsBillingEmail: boolean
  addressLine1: string
  addressLine2: string
  city: string
  province: string
  country: string
  postcode: string
  internalReference: string
  taxId: string
  companyNameTh: string
  companyNameEn: string
  branch: string
  vatRegistered: boolean
  contactPerson: string
  idType: 'citizen_id' | 'passport' | ''
  idNumber: string
  fullNameTh: string
  fullNameEn: string
  individualTaxId: string
  payInMethod: 'acquiring' | 'card'
  cardholderName: string
  cardNumber: string
  expiryDate: string
  payoutMethod: 'bank_account' | 'promptpay'
  bankName: string
  accountNumber: string
  accountName: string
  promptPayType: 'phone' | 'citizen_id' | 'tax_id' | ''
  promptPayId: string
  promptPayName: string
  amountOwed: string
  source: string
  dateCreated: string
  isArchived: boolean
}
export const mockSuppliers: Supplier[] = [
  {
    id: '1',
    supplierType: 'company',
    name: 'Test Company Pvt Ltd',
    email: 'ahmed+supplier@bankofmaldives.com.mv',
    phone: '+9603001234',
    useAsBillingEmail: true,
    addressLine1: 'H. Maaveyo, Sosun Magu',
    addressLine2: 'Henveiru',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20026',
    internalReference: 'SUP-001',
    taxId: '1023456-3',
    companyNameTh: 'Test Company Pvt Ltd',
    companyNameEn: 'Test Company Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ahmed Saleem',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730000123456',
    accountName: 'Test Company Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 9,393.00`,
    source: 'Pomelo',
    dateCreated: '13/03/2026, 12:26',
    isArchived: false,
  },
  {
    id: '2',
    supplierType: 'company',
    name: 'Reef Beverages Pvt Ltd',
    email: 'rasheed@reefbev.mv',
    phone: '+9603055901',
    useAsBillingEmail: true,
    addressLine1: 'M. Athireege, Majeedhee Magu',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20064',
    internalReference: 'TEA-002',
    taxId: '1011223-7',
    companyNameTh: 'Reef Beverages Pvt Ltd',
    companyNameEn: 'Reef Beverages Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Hassan Rasheed',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maldives Islamic Bank',
    accountNumber: '90100100012345',
    accountName: 'Reef Beverages Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '10/01/2026, 09:15',
    isArchived: false,
  },
  {
    id: '3',
    supplierType: 'company',
    name: 'Atoll Packaging Solutions Pvt Ltd',
    email: 'ibrahim@atollpack.mv',
    phone: '+9603778899',
    useAsBillingEmail: false,
    addressLine1: 'Lot 10584, Reethigas Magu',
    addressLine2: 'Phase 1',
    city: 'Hulhumalé',
    province: 'Hulhumalé',
    country: 'Maldives',
    postcode: '23000',
    internalReference: 'PKG-003',
    taxId: '1019876-2',
    companyNameTh: 'Atoll Packaging Solutions Pvt Ltd',
    companyNameEn: 'Atoll Packaging Solutions Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ibrahim Naseer',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'State Bank of India (Malé)',
    accountNumber: '34561234567',
    accountName: 'Atoll Packaging Solutions Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 45,000.00`,
    source: 'Pomelo',
    dateCreated: '05/02/2026, 14:30',
    isArchived: false,
  },
  {
    id: '4',
    supplierType: 'individual',
    name: 'Mohamed Waheed',
    email: 'm.waheed@gmail.com',
    phone: '+9607712345',
    useAsBillingEmail: true,
    addressLine1: 'G. Fehivinaresgr, Buruzu Magu',
    addressLine2: 'Henveiru',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20094',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A123456',
    fullNameTh: 'Mohamed Waheed',
    fullNameEn: 'Mohamed Waheed',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '+9607712345',
    promptPayName: 'Mohamed Waheed',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '12/04/2026, 11:20',
    isArchived: true,
  },
  {
    id: '5',
    supplierType: 'company',
    name: 'Maldives Fresh Produce Pvt Ltd',
    email: 'procurement@mvfresh.mv',
    phone: '+9603234567',
    useAsBillingEmail: true,
    addressLine1: 'M. Sunbird, Kalaafaanu Hingun',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20074',
    internalReference: 'FRESH-005',
    taxId: '1004567-8',
    companyNameTh: 'Maldives Fresh Produce Pvt Ltd',
    companyNameEn: 'Maldives Fresh Produce Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Aishath Nazima',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730000456789',
    accountName: 'Maldives Fresh Produce Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 128,500.00`,
    source: 'Pomelo',
    dateCreated: '20/05/2026, 08:45',
    isArchived: false,
  },
  {
    id: '6',
    supplierType: 'company',
    name: 'Malé Digital Print House',
    email: 'sales@malidigitalprint.mv',
    phone: '+9603267890',
    useAsBillingEmail: true,
    addressLine1: 'H. Kahimagu, Chandhanee Magu',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20184',
    internalReference: 'PRT-006',
    taxId: '1003456-4',
    companyNameTh: 'Malé Digital Print House Pvt Ltd',
    companyNameEn: 'Malé Digital Print House Pvt Ltd',
    branch: '00001',
    vatRegistered: true,
    contactPerson: 'Ali Rasheed',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Ali Rasheed',
    cardNumber: '4111XXXXXXXX4242',
    expiryDate: '09/27',
    payoutMethod: 'bank_account',
    bankName: 'Habib Bank Maldives',
    accountNumber: '0019876543',
    accountName: 'Malé Digital Print House Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 22,750.00`,
    source: 'Manual entry',
    dateCreated: '03/01/2026, 16:10',
    isArchived: false,
  },
  {
    id: '7',
    supplierType: 'company',
    name: 'Southern Atoll Logistics Pvt Ltd',
    email: 'accounts@southatolllog.mv',
    phone: '+9606888456',
    useAsBillingEmail: true,
    addressLine1: 'Manzil, Link Road',
    addressLine2: 'Hithadhoo',
    city: 'Addu City',
    province: 'Seenu Atoll',
    country: 'Maldives',
    postcode: '19000',
    internalReference: 'LOG-007',
    taxId: '1008765-1',
    companyNameTh: 'Southern Atoll Logistics Pvt Ltd',
    companyNameEn: 'Southern Atoll Logistics Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Hussain Manik',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730009876543',
    accountName: 'Southern Atoll Logistics Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 67,200.00`,
    source: 'Pomelo',
    dateCreated: '15/04/2026, 10:30',
    isArchived: false,
  },
  {
    id: '8',
    supplierType: 'individual',
    name: 'Fathimath Shaira',
    email: 'fathimath.shaira@hotmail.com',
    phone: '+9607823456',
    useAsBillingEmail: true,
    addressLine1: 'Ranveli, Boalhakuribee Hingun',
    addressLine2: '',
    city: 'Fuvahmulah',
    province: 'Gnaviyani Atoll',
    country: 'Maldives',
    postcode: '18000',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A234567',
    fullNameTh: 'Fathimath Shaira',
    fullNameEn: 'Fathimath Shaira',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7710001234567',
    accountName: 'Fathimath Shaira',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 15,000.00`,
    source: 'Manual entry',
    dateCreated: '22/02/2026, 13:45',
    isArchived: false,
  },
  {
    id: '9',
    supplierType: 'company',
    name: 'Island Agriculture Pvt Ltd',
    email: 'info@islandag.mv',
    phone: '+9605444567',
    useAsBillingEmail: true,
    addressLine1: 'Finifenmaage, Main Road',
    addressLine2: 'Thoddoo',
    city: 'Thoddoo',
    province: 'Alif Alif Atoll',
    country: 'Maldives',
    postcode: '03020',
    internalReference: 'AGR-009',
    taxId: '1001122-9',
    companyNameTh: 'Island Agriculture Pvt Ltd',
    companyNameEn: 'Island Agriculture Pvt Ltd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Khadeeja Saeed',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maldives Islamic Bank',
    accountNumber: '90100200012345',
    accountName: 'Island Agriculture Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '08/02/2026, 09:00',
    isArchived: false,
  },
  {
    id: '10',
    supplierType: 'company',
    name: 'Indian Ocean Seafood Export Pvt Ltd',
    email: 'export@iodseafood.mv',
    phone: '+9606522234',
    useAsBillingEmail: false,
    addressLine1: 'Reef View, Sosun Magu',
    addressLine2: 'Felivaru Industrial Zone',
    city: 'Kulhudhuffushi',
    province: 'Haa Dhaalu Atoll',
    country: 'Maldives',
    postcode: '02040',
    internalReference: 'SEA-010',
    taxId: '1006543-5',
    companyNameTh: 'Indian Ocean Seafood Export Pvt Ltd',
    companyNameEn: 'Indian Ocean Seafood Export Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mariyam Didi',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730001119876',
    accountName: 'Indian Ocean Seafood Export Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 234,100.00`,
    source: 'Pomelo',
    dateCreated: '01/11/2025, 11:15',
    isArchived: false,
  },
  {
    id: '11',
    supplierType: 'company',
    name: 'Malé Office Supplies Pvt Ltd',
    email: 'orders@maleoffice.mv',
    phone: '+9603222333',
    useAsBillingEmail: true,
    addressLine1: 'M. Skybird, Boduthakurufaanu Magu',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20094',
    internalReference: 'OFF-011',
    taxId: '1002233-0',
    companyNameTh: 'Malé Office Supplies Pvt Ltd',
    companyNameEn: 'Malé Office Supplies Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Aminath Shazlee',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Aminath Shazlee',
    cardNumber: '5500XXXXXXXX1234',
    expiryDate: '12/28',
    payoutMethod: 'bank_account',
    bankName: 'Mauritius Commercial Bank Maldives',
    accountNumber: '9881234567',
    accountName: 'Malé Office Supplies Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 8,450.00`,
    source: 'Manual entry',
    dateCreated: '28/01/2026, 15:20',
    isArchived: false,
  },
  {
    id: '12',
    supplierType: 'individual',
    name: 'Ali Naseem',
    email: 'ali.naseem@gmail.com',
    phone: '+9609654321',
    useAsBillingEmail: true,
    addressLine1: 'Daisy Villa, Lily Magu',
    addressLine2: 'Galolhu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20146',
    internalReference: 'FRL-012',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A345678',
    fullNameTh: 'Ali Naseem',
    fullNameEn: 'Ali Naseem',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'citizen_id',
    promptPayId: 'A345678',
    promptPayName: 'Ali Naseem',
    amountOwed: `${getTenant().currency.code} 3,200.00`,
    source: 'Manual entry',
    dateCreated: '14/02/2026, 09:30',
    isArchived: false,
  },
  {
    id: '13',
    supplierType: 'company',
    name: 'Northern Textile Mills Pvt Ltd',
    email: 'sales@northerntextile.mv',
    phone: '+9606520901',
    useAsBillingEmail: true,
    addressLine1: 'Light House, Bandaaru Magu',
    addressLine2: '',
    city: 'Kulhudhuffushi',
    province: 'Haa Dhaalu Atoll',
    country: 'Maldives',
    postcode: '02040',
    internalReference: 'TXT-013',
    taxId: '1007788-3',
    companyNameTh: 'Northern Textile Mills Pvt Ltd',
    companyNameEn: 'Northern Textile Mills Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Abdulla Latheef',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maldives Islamic Bank',
    accountNumber: '90100300012345',
    accountName: 'Northern Textile Mills Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 89,300.00`,
    source: 'Pomelo',
    dateCreated: '19/03/2026, 14:00',
    isArchived: false,
  },
  {
    id: '14',
    supplierType: 'company',
    name: 'Atoll Coconut Products Pvt Ltd',
    email: 'info@atollcoconut.mv',
    phone: '+9606655123',
    useAsBillingEmail: true,
    addressLine1: 'Roashanee, Hithadhoo Link Road',
    addressLine2: '',
    city: 'Thinadhoo',
    province: 'Gaafu Dhaalu Atoll',
    country: 'Maldives',
    postcode: '17010',
    internalReference: 'COC-014',
    taxId: '1009900-2',
    companyNameTh: 'Atoll Coconut Products Pvt Ltd',
    companyNameEn: 'Atoll Coconut Products Pvt Ltd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Aishath Reesha',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'tax_id',
    promptPayId: '1009900-2',
    promptPayName: 'Atoll Coconut Products Pvt Ltd',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '05/12/2025, 10:00',
    isArchived: false,
  },
  {
    id: '15',
    supplierType: 'company',
    name: 'Reef Clean Services Pvt Ltd',
    email: 'billing@reefclean.mv',
    phone: '+9603311122',
    useAsBillingEmail: true,
    addressLine1: 'H. Velikulha, Filigas Magu',
    addressLine2: 'Galolhu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20196',
    internalReference: 'CLN-015',
    taxId: '1005566-6',
    companyNameTh: 'Reef Clean Services Pvt Ltd',
    companyNameEn: 'Reef Clean Services Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Hassan Faruhad',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Commercial Bank of Maldives',
    accountNumber: '55512345670',
    accountName: 'Reef Clean Services Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 18,900.00`,
    source: 'Manual entry',
    dateCreated: '11/05/2026, 08:30',
    isArchived: false,
  },
  {
    id: '16',
    supplierType: 'individual',
    name: 'Sheen Hassan',
    email: 'sheen.hassan@outlook.com',
    phone: '+9609555678',
    useAsBillingEmail: true,
    addressLine1: 'Athireege Aage, Orchid Magu',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20256',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'passport',
    idNumber: 'M0123456',
    fullNameTh: 'Sheen Hassan',
    fullNameEn: 'Sheen Hassan',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '+9609555678',
    promptPayName: 'Sheen Hassan',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '02/03/2026, 11:00',
    isArchived: false,
  },
  {
    id: '17',
    supplierType: 'company',
    name: 'Eastern Atoll Rice Trading Pvt Ltd',
    email: 'trade@earice.mv',
    phone: '+9606722234',
    useAsBillingEmail: true,
    addressLine1: 'Reef Side, Bodumagu',
    addressLine2: '',
    city: 'Naifaru',
    province: 'Lhaviyani Atoll',
    country: 'Maldives',
    postcode: '07060',
    internalReference: 'RICE-017',
    taxId: '1004455-7',
    companyNameTh: 'Eastern Atoll Rice Trading Pvt Ltd',
    companyNameEn: 'Eastern Atoll Rice Trading Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mohamed Hafiz',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maldives Islamic Bank',
    accountNumber: '90100400012345',
    accountName: 'Eastern Atoll Rice Trading Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 156,000.00`,
    source: 'Pomelo',
    dateCreated: '25/01/2026, 13:15',
    isArchived: false,
  },
  {
    id: '18',
    supplierType: 'company',
    name: 'Baa Atoll Industries Pvt Ltd',
    email: 'procurement@baaatollind.mv',
    phone: '+9606601234',
    useAsBillingEmail: true,
    addressLine1: 'Heera Manzil, Main Road',
    addressLine2: '',
    city: 'Eydhafushi',
    province: 'Baa Atoll',
    country: 'Maldives',
    postcode: '06010',
    internalReference: 'RBR-018',
    taxId: '1003344-1',
    companyNameTh: 'Baa Atoll Industries Pvt Ltd',
    companyNameEn: 'Baa Atoll Industries Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ismail Saeed',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730008881234',
    accountName: 'Baa Atoll Industries Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 312,500.00`,
    source: 'API',
    dateCreated: '14/09/2025, 09:45',
    isArchived: false,
  },
  {
    id: '19',
    supplierType: 'company',
    name: 'Sun Atoll Tour Operators Pvt Ltd',
    email: 'finance@sunatolltours.mv',
    phone: '+9606889012',
    useAsBillingEmail: false,
    addressLine1: 'Falsea, Mariyaadhu Magu',
    addressLine2: 'Phase 2',
    city: 'Hulhumalé',
    province: 'Hulhumalé',
    country: 'Maldives',
    postcode: '23000',
    internalReference: 'TOUR-019',
    taxId: '1008877-2',
    companyNameTh: 'Sun Atoll Tour Operators Pvt Ltd',
    companyNameEn: 'Sun Atoll Tour Operators Pvt Ltd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Aishath Liusha',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Aishath Liusha',
    cardNumber: '4532XXXXXXXX8901',
    expiryDate: '03/28',
    payoutMethod: 'bank_account',
    bankName: 'HSBC Maldives',
    accountNumber: '77712345670',
    accountName: 'Sun Atoll Tour Operators Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 41,600.00`,
    source: 'Pomelo',
    dateCreated: '28/02/2026, 16:30',
    isArchived: false,
  },
  {
    id: '20',
    supplierType: 'company',
    name: 'Old Warehouse Supplies Pvt Ltd',
    email: 'info@oldwarehouse.mv',
    phone: '+9603344455',
    useAsBillingEmail: true,
    addressLine1: 'H. Athireege, Fareedhee Magu',
    addressLine2: 'Maafannu',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20256',
    internalReference: 'WH-020',
    taxId: '1001100-0',
    companyNameTh: 'Old Warehouse Supplies Pvt Ltd',
    companyNameEn: 'Old Warehouse Supplies Pvt Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mohamed Niyaz',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7730001231234',
    accountName: 'Old Warehouse Supplies Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '18/05/2024, 10:00',
    isArchived: true,
  },
  {
    id: '21',
    supplierType: 'individual',
    name: 'Aminath Yusra',
    email: 'aminath.yusra@yahoo.com',
    phone: '+9609345678',
    useAsBillingEmail: true,
    addressLine1: 'Roashan, Iramaa Magu',
    addressLine2: 'Henveiru',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20094',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A456789',
    fullNameTh: 'Aminath Yusra',
    fullNameEn: 'Aminath Yusra',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Maldives',
    accountNumber: '7710003456789',
    accountName: 'Aminath Yusra',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 7,500.00`,
    source: 'Manual entry',
    dateCreated: '06/01/2026, 14:20',
    isArchived: false,
  },
  {
    id: '22',
    supplierType: 'company',
    name: 'Defunct Trading Pvt Ltd',
    email: 'old@defuncttrading.mv',
    phone: '+9603311100',
    useAsBillingEmail: true,
    addressLine1: 'M. Vinares, Janavaree Magu',
    addressLine2: 'Henveiru',
    city: 'Malé',
    province: 'Malé',
    country: 'Maldives',
    postcode: '20094',
    internalReference: 'DEF-022',
    taxId: '1009999-3',
    companyNameTh: 'Defunct Trading Pvt Ltd',
    companyNameEn: 'Defunct Trading Pvt Ltd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'N/A',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'ICICI Bank (Maldives)',
    accountNumber: '33312345670',
    accountName: 'Defunct Trading Pvt Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '01/03/2024, 08:00',
    isArchived: true,
  },
]
export interface InvitedSupplier {
  id: string
  name: string
  supplierType: 'company' | 'individual'
  inviteLink: string
  dateInvited: string
  daysAgo: number
}
export const mockInvitedSuppliers: InvitedSupplier[] = [
  {
    id: 'inv-1',
    name: 'Maldives Fresh Market Pvt Ltd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/a1b2c3d4e5',
    dateInvited: '14/02/2026, 10:30',
    daysAgo: 30,
  },
  {
    id: 'inv-2',
    name: 'Nazran Adam',
    supplierType: 'individual',
    inviteLink: '/supplier-onboarding/f6g7h8i9j0',
    dateInvited: '05/03/2026, 14:15',
    daysAgo: 11,
  },
  {
    id: 'inv-3',
    name: 'Maldives Organic Produce Pvt Ltd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/k1l2m3n4o5',
    dateInvited: '12/03/2026, 09:00',
    daysAgo: 4,
  },
]
